import Question from "./question.js"
import OrderingQuestionComponent from "../components/questions/ordering-question.jsx"
import OrderingReportComponent from "../components/reports/ordering-report.jsx";
import OrderingPreviewComponent from "../components/previews/ordering-preview.jsx";
class OrderingQuestion extends Question {
  component(mode) {
    switch(mode) {
      case "student-facing-report":
        return OrderingReportComponent;
      case "preview":
        return OrderingPreviewComponent;
      default:
        return OrderingQuestionComponent;
    }
  }
}

export default OrderingQuestion;